<template>
<div id="uploading">
   <div id="progress-container" v-if="isUploading">
      <div class="uploaded-message">Uploading {{toBeUploadedFiles.length}} File{{isPlural}}...</div>
      <div class="files-container">
         <div class="file-progress-container">
            <div class="file-row-load-indicator" :style="loadStyle"></div>
            <div class="file-percentage">{{parseInt((uploadProgress/uploadTotal) * 100)}}%</div>
         </div>
      </div>
   </div>
   <div v-else-if="!isInitial && !isUploading && !isFailed" class="success-text success">
      Successfully uploaded {{uploadedFiles.length}} of {{toBeUploadedFiles.length}} file{{isPlural}}.
   </div>
   <div v-else-if="isFailed" class="fail-msg-wrapper">
      <div class="failed-header error">Darn.</div>
      <div class="failed-msg error">The following file(s) aren't supported:</div>
      <div class="files-list-wrapper" v-bar>
         <div class="files-list-inner">
            <div v-if="invalidExtFiles.length > 0" id="invalid_files_container">
               <div v-for="file of invalidExtFiles" class="invalid-file">{{file.name}}</div>
            </div>
         </div>
      </div>
   </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
   data() {
      return {
         uploadFieldName: '',
         uploadError: null,
         successFiles: [],
         fileCount: 0
      }
   },

   computed: {
      ...mapState('global', 
         [
          'currentStatus',
          'toBeUploadedFiles',
          'uploadErrorFiles',
          'invalidExtFiles', 
          'uploadedFiles', 
          'uploadProgress', 
          'uploadTotal'
         ]
      ),

      ...mapGetters('global', [
         'isInitial',
         'isUploading',
         'isIngesting',
         'isFetching', 
         'isSuccess', 
         'isFailed',   
      ]),

      uploadPercentageProgress() {
         return Math.floor((this.uploadProgress / this.uploadTotal) * 100);
      },

      loadStyle() {
         return "width: " + this.uploadPercentageProgress + "%;";
      },

      isPlural() {
         return this.toBeUploadedFiles.length > 1 ? 's' : '';
      }
   },

}
</script>

<style lang="scss" scoped>
#uploading {
   display: flex;
   justify-content: center;
   height: 100%;
   align-items: center;
}

#progress-container {
   display: flex;
   flex-direction: column;
   position: relative;
   width: 340px;
   height: 237px;
   text-align: center;
   background-image: url('./../../assets/img/media/upload-progress-graphic.png');
   background-repeat: no-repeat;
   background-position: center center;
   background-size: 120px 66px;
}

.uploaded-message {
   margin-top: auto;
}

.file-progress-container {
   display: flex;
   height: 10px;
   background-color: #414f63;
    border-radius: 6px;

   &:not(:last-child) {
      border-bottom: none;
   }

   .file-row-load-indicator {
      background: #309bed;
      z-index: 0;
   }
}

.file-percentage {
   font-size: 17px;
   color: #7f8fa4;
   position: absolute;
   bottom: -28px;
   right: 0;
}

.filestyle {
   text-decoration: underline;
   color: $bard-gray;
}

.fail-msg-wrapper {
   .failed-header {
      font-size: 24px;
      font-size: 1.5rem;
   }
   .failed-msg {
      font-size: 20px;
      font-size: 1.25rem;
   }
   .error {
      color: #e9fa00;
   }

}
.files-list-wrapper {
   width: 95%;
   height: 200px;
   min-height: 100px;
   background-color: transparent;
   overflow-x: hidden;
   overflow-y: scroll;

   &.vb-invisible {
      .files-list-inner {
         &::after {
         background-color: transparent;
         }
      }
   }

   &.vb-visible {
      &::after {
         content: '';
         width: 4px;
         height: 100%;
         position: absolute;
         right: .5em;
         top: 0;
         z-index: 1;
         background-color: #333e51;
      }
   }

}
#invalid_files_container {
   padding: 10px 20px;

   .invalid-file {
      font-size: 1rem;
   }
}
</style>